import React, { Component } from "react";
import classnames from "classnames";

import { SortOrder } from "@formant/core/model/SortOrder";
import { Icon } from "@formant/ui/component/common/Icon";

import * as styles from "./SortIcon.scss";

export interface ISortIconProps {
    active: boolean;
    order: SortOrder;
    className?: string;
}

export class SortIcon extends Component<ISortIconProps> {
    public render() {
        const { active, order, className } = this.props;
        return (
            <Icon
                className={classnames(
                    styles["sort-icon"],
                    active && styles.active,
                    className,
                )}
                name={
                    !active || order === "asc" ? "chevron-up" : "chevron-down"
                }
                size="18"
            />
        );
    }
}
